// 缩放
function resizeFont(base){
	const size = window.innerWidth * (base / 1920) * 0.88;
    return size
}

export default {
	resizeFont
}